import React, { Component } from 'react'

import {
  GalleryPopup,
  Gallery,
  Button,
  Photo,
  GalleryPhoto,
  PopupGallery,
  X
} from './styles'

class PhotoGallery extends Component {
  state = {
    showModal: false,
    selected: 0
  }

  fClicked = num => {
    this.setState({ selected: num, showModal: true })
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  keyDown = onclick => e => {
    if (e.keyCode === 13) {
      onclick()
    }
  }

  render() {
    const numPhotos = this.props.photos ? this.props.photos.length : 0
    const sqrt = Math.floor(Math.sqrt(numPhotos))
    const rows = Math.ceil(numPhotos / sqrt)

    const rowArray = []

    for (let i = 0; i < numPhotos; i += sqrt) {
      rowArray.push(this.props.photos.slice(i, i + sqrt))
    }

    return (
      <div>
        {rowArray.map(photos => (
          <Gallery key={`main${photos[0].feature}`}>
            {photos.map(set => (
              <Button
                key={set.feature}
                onClick={() => this.fClicked(this.props.photos.indexOf(set))}
              >
                <Photo
                  key={set.feature}
                  src={set.feature}
                  columns={sqrt}
                  rows={rows}
                />
              </Button>
            ))}
          </Gallery>
        ))}
        <GalleryPopup
          isOpen={this.state.showModal}
          shouldCloseOnOverlayClick
          onRequestClose={this.toggleModal}
          style={{
            overlay: {
              width: '100%',
              height: '100%'
            },
            content: {
              width: '90vw',
              height: '90vh',
              margin: '5vh 5vw 5vh 5vw'
            }
          }}
        >
          <PopupGallery style={{ backgroundColor: '#d0e2ef' }}>
            <X
              onClick={this.toggleModal}
              role="button"
              tabIndex="0"
              onKeyDown={this.keyDown(this.toggleModal)}
            >
              ✖
            </X>
            {this.props.photos.length > 0 &&
              this.props.photos[this.state.selected].gallery.map(photo => (
                <GalleryPhoto src={photo} key={photo} />
              ))}
          </PopupGallery>
        </GalleryPopup>
      </div>
    )
  }
}

export default PhotoGallery



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/components/PhotoGallery/index.js